import styled from 'styled-components';

export const FiltersContainer = styled.div`
  display: flex;
  gap: 12px;
  margin-bottom: 16px;
`;

export const FilterButton = styled.button<{ active?: boolean }>`
  display: flex;
  padding: 4px 12px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 4px;
  border: 1px solid ${({ theme, active }) => (active ? theme.colors.green7 : theme.colors.black3)};
  background: ${({ theme, active }) => (active ? theme.colors.green1 : 'transparent')};
  color: ${({ theme, active }) => (active ? theme.colors.green9 : theme.colors.black7)};

  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  cursor: pointer;

  &:hover {
    border-radius: 4px;
    border: 1px solid ${({ theme, active }) => (active ? theme.colors.green7 : theme.colors.black4)};
    background: ${({ theme, active }) => (active ? theme.colors.green2 : theme.colors.black2)};
    border-radius: 4px;
  }
`;
